import * as Yup from 'yup';
import { ingredientTypes, measurementTyes } from '../constants';

export const ingredientValidationSchema = Yup.object().shape({
  name: Yup.string().required('The ingredient name is required'),
  type: Yup.string()
    .oneOf(ingredientTypes, 'The ingredient type is not valid')
    .required('The ingredient type is required'),
  measurementType: Yup.string()
    .oneOf(measurementTyes, 'The unit of measurement is not valid')
    .required('The ingredient unit of measurement is required')
});

export const amountAdjustmentValidationSchema = Yup.object().shape({
  amount: Yup.number().required('The adjustment amount is required')
});



// WEBPACK FOOTER //
// ./src/validation/ingredient.js